/**
 * Accessibility Enhancements for CoraCreaCrafts
 * Phase 2 P0 Fixes - WCAG 2.1 AA Compliance
 *
 * Fixes:
 * - P0-3: Wishlist counter dynamic aria-label updates
 * - Ensures screen reader users hear count changes
 */

(function() {
  'use strict';

  /**
   * Update wishlist counter aria-label with current count
   * Follows same pattern as cart counter for consistency
   */
  function updateWishlistCounterAccessibility() {
    try {
      const counter = document.getElementById('wishlist-counter');
      const countElement = document.getElementById('wishlist-count');

      if (!counter || !countElement) {
        return;
      }

      // Get count from element or localStorage
      let count = parseInt(countElement.textContent) || 0;

      // Try to get from localStorage if count is 0
      if (count === 0) {
        try {
          const wishlistData = localStorage.getItem('coracrea_wishlist');
          if (wishlistData) {
            const items = JSON.parse(wishlistData);
            count = Array.isArray(items) ? items.length : 0;
          }
        } catch (e) {
          console.error('Error reading wishlist from localStorage:', e);
        }
      }

      // Update aria-label with count
      const itemText = count === 1 ? 'item' : 'items';
      counter.setAttribute('aria-label', `Wishlist (${count} ${itemText})`);

      // Update count display
      countElement.textContent = count;

      // Show/hide count badge
      if (count > 0) {
        countElement.removeAttribute('hidden');
      } else {
        countElement.setAttribute('hidden', '');
      }

      // The aria-live="polite" on the counter element will announce changes
    } catch (error) {
      console.error('Error updating wishlist counter accessibility:', error);
    }
  }

  /**
   * Initialize accessibility enhancements
   */
  function init() {
    // Update wishlist counter on page load
    updateWishlistCounterAccessibility();

    // Listen for storage events (updates from other tabs)
    window.addEventListener('storage', function(e) {
      if (e.key === 'coracrea_wishlist') {
        updateWishlistCounterAccessibility();
      }
    });

    // Listen for custom wishlist events (if wishlist system dispatches them)
    document.addEventListener('wishlist:updated', updateWishlistCounterAccessibility);
    document.addEventListener('wishlist:added', updateWishlistCounterAccessibility);
    document.addEventListener('wishlist:removed', updateWishlistCounterAccessibility);

    // Periodic check as fallback (every 2 seconds when page visible)
    let checkInterval;

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
      } else {
        checkInterval = setInterval(updateWishlistCounterAccessibility, 2000);
      }
    });

    // Start interval if page is visible
    if (!document.hidden) {
      checkInterval = setInterval(updateWishlistCounterAccessibility, 2000);
    }

    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
      if (checkInterval) {
        clearInterval(checkInterval);
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export for manual updates if needed
  window.WishlistAccessibility = {
    updateCounter: updateWishlistCounterAccessibility
  };
})();
